import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * PaginationFooter — shows page info and prev/next buttons.
 * Props: page, pageSize, total, onPageChange
 */
export function PaginationFooter({ page = 1, pageSize = 20, total = 0, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t text-sm text-muted-foreground">
      <span>{total === 0 ? 'No results' : `${from}-${to} of ${total}`}</span>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)} data-testid="pagination-prev">
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="px-2">Page {page} of {totalPages}</span>
        <Button variant="ghost" size="sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} data-testid="pagination-next">
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
